@let form = block();
<div
  [formGroup]="form"
  class="grid grid-cols-1 gap-4 lg:grid-cols-[12rem_minmax(0,1fr)]">
  <div class="text-standard-text-secondary pt-3 pl-8 text-sm font-semibold">
    Logos
  </div>
  <div class="flex min-w-0 flex-col gap-3">
    @for (row of rows(true); track row.form) {
      <ng-container *ngTemplateOutlet="providerRow; context: { row: row }" />
    }
    <div class="text-standard-text-secondary mt-2 text-xs font-semibold">
      {{ cmsTextProvider.footer.hidden }}
    </div>
    @for (row of rows(false); track row.form) {
      <ng-container *ngTemplateOutlet="providerRow; context: { row: row }" />
    }
  </div>
</div>

<ng-template #providerRow let-row="row">
  <div class="flex items-start gap-3">
    <div class="flex min-h-12 flex-col items-center justify-center">
      <button
        type="button"
        class="text-info-main flex h-6 cursor-pointer items-center disabled:cursor-default disabled:opacity-40"
        [disabled]="moveTarget(row.index, -1) === -1"
        [attr.aria-label]="
          paymentProviderName(row.form.controls.providerId.value) +
          ' nach oben verschieben'
        "
        (click)="moveProvider(row.index, -1)">
        <span class="material-symbols-rounded text-base" aria-hidden="true"
          >keyboard_arrow_up</span
        >
      </button>
      <button
        type="button"
        class="text-info-main flex h-6 cursor-pointer items-center disabled:cursor-default disabled:opacity-40"
        [disabled]="moveTarget(row.index, 1) === -1"
        [attr.aria-label]="
          paymentProviderName(row.form.controls.providerId.value) +
          ' nach unten verschieben'
        "
        (click)="moveProvider(row.index, 1)">
        <span class="material-symbols-rounded text-base" aria-hidden="true"
          >keyboard_arrow_down</span
        >
      </button>
    </div>
    <div class="grid min-w-0 flex-1 grid-cols-1 gap-4 lg:grid-cols-3">
      <div class="box-border flex w-full bg-inherit text-base">
        <div
          class="border-input-ring border-input rounded-input flex w-16 shrink-0 items-center justify-center rounded-r-none! border-r-0 bg-transparent px-2">
          <span class="material-symbols-rounded" aria-hidden="true">image</span>
        </div>
        <div
          class="border-input-ring border-input rounded-r-input p-input flex w-full min-w-0 items-center gap-2 bg-inherit">
          <img
            class="h-6 max-w-24 object-contain"
            [src]="
              paymentProviderStore.getThumbnailPath(
                row.form.controls.providerId.value
              )
            "
            [alt]="paymentProviderName(row.form.controls.providerId.value)" />
          <span class="truncate text-sm">{{
            paymentProviderName(row.form.controls.providerId.value)
          }}</span>
        </div>
      </div>
      <aw-translation-accessibility-text-input
        [entityType]="EntityType.footerPaymentArea"
        [relationType]="TextRelationType.imageAlt"
        [id]="'payment-provider-alt-' + index() + '-' + row.index"
        [formControl]="row.form.controls.description"
        [label]="cmsTextProvider.footer.description" />
      <aw-text-input
        [id]="'payment-provider-url-' + index() + '-' + row.index"
        [formControl]="row.form.controls.url"
        [label]="cmsTextProvider.footer.linkAddressLabel" />
    </div>
    <button
      type="button"
      class="border-standard-outline-light flex h-12 w-12 shrink-0 items-center justify-center rounded-md border"
      [attr.aria-label]="
        paymentProviderName(row.form.controls.providerId.value) +
        (row.form.controls.visible.value ? ' ausblenden' : ' einblenden')
      "
      (click)="toggleProvider(row.form)">
      <span class="material-symbols-rounded text-base" aria-hidden="true">
        {{ row.form.controls.visible.value ? 'visibility_off' : 'visibility' }}
      </span>
    </button>
  </div>
</ng-template>
